<textarea
  [rows]="rowsCount"
  [class]="class"
  nz-input
  [placeholder]="getPlaceholder()"
  [formControl]="control"
  [minlength]="min"
  [maxlength]="max"
  [readonly]="readOnly"
  class="form-textarea"
  [class.error]="
    (this.isFormSubmitted || this.control?.touched) && this.control?.errors
  "
></textarea>
